import { MLText, mlBroker } from '../../services/MLText';
import { dmBooking }        from './xv-bookings';
import { dmLoading }        from '../loading/loading';

export class BookingDetailsViewModel {
    NewLoading: (pMessage: string) => dmLoading;
    Dismiss:    ()                 => void;

    mlText:     MLText;
    app:        mlBroker;
    ml:         mlBroker;
    LangID:     number;

    Booking:    dmBooking;

    constructor(
         pMLText:     MLText
        ,pBooking:    dmBooking
        ,pNewLoading: (pMessage: string) => dmLoading
        ,pDismiss:    ()                 => void
    ) {
        this.mlText     = pMLText;
        this.LangID     = this.mlText.GetLangID();
        this.app        = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml         = this.mlText.GetBroker(
            'HotelAreaBookings'
        );

        this.Booking    = pBooking;
        this.NewLoading = pNewLoading;
        this.Dismiss    = pDismiss;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.Booking.LoadRoomReservations(() => { loading.Dismiss(); });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/bookings/xv-booking-details.ts